import * as React from "react";
import { jnstyls } from '~/utils/helpers'

import { Title, ImgTitle, Subtitle, Ctas, Body } from './contents'

import * as styles from "~/styles/home/wraps.module.scss"

const Overlay = ({ block, item, index, pstyles={} }) => {
  const { contents } = item

  const desk_align = (block.overlay_align && block.overlay_align !== 'left') ? block.overlay_align : false
  const mobi_align = (block.mob_overlay_align && block.mob_overlay_align !== 'left') ? block.mob_overlay_align : false
  let alt_title = {copy: '', url: ''}
  if (block.img_title) {
    const title_obj = contents.find(x => x.type === 'title')
    if (title_obj) alt_title = {copy: title_obj.copy, url: ''}
  }
  
  return (
    <>
      {desk_align && (
        <style>
          {`@media only screen and (min-width: 820px) {
            .overlay${block.id} {
              align-items: ${desk_align === 'right' ? 'flex-end' : desk_align};
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: ${desk_align};
            }
          }`}
        </style>
      )}
      {mobi_align && (
        <style>
          {`@media only screen and (max-width: 819px) {
            .overlay${block.id} {
              align-items: ${mobi_align === 'right' ? 'flex-end' : mobi_align};
              display: flex;
              flex-direction: column;
              justify-content: center;
              text-align: ${mobi_align};
            }
          }`}
        </style>
      )}
      {block.id === 1466 && (
        <style>
          {`@media only screen and (max-width: 819px) {
            [mid="1466"] .${styles.overlay}.overlay${block.id} {
              padding-bottom: 2em;
              justify-content: flex-end;
            }
          }`}
        </style>
      )}
      {block.id === 1907 && (
        <style>
          {`@media only screen and (min-width: 820px) {
              [mid="1907"] .${styles.overlay}.overlay${block.id} h1 {
                font-size: 6.1rem;
              }
              [mid="1907"] .${styles.overlay}.overlay${block.id} .contents-module--copy_cta--9880e {
                margin-top: 3rem;
              }
            }
            @media only screen and (max-width: 819px) {
              [mid="1907"] .${styles.overlay}.overlay${block.id} h1 {
                font-size: 6.1rem;
              }
            }
          `}
        </style>
      )}
      {(block.id === 1945) && (
        <style>
          {`@media only screen and (max-width: 819px) {
            [mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
              padding-bottom: 8em;
              justify-content: flex-end;
            }
          }`}
        </style>
      )}
      {(block.id === 2543) && (
        <style>
          {`[mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
              font-weight: bold;
              font-size: 1.5rem;
            }
            @media only screen and (min-width: 820px) {
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
                justify-content: flex-end;
              }
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} > div {
                margin-bottom: 5em;
                margin-top: 0;
              }
            }
            @media only screen and (max-width: 819px) {
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
                justify-content: flex-start;
              }
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} > div {
                margin-top: 67vh;
              }
            }
          `}
        </style>
      )}
      {(block.id === 2530) && (
        <style>
          {`[mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
              font-size: 1.5rem;
              font-weight: bold;
            }
            @media only screen and (max-width: 819px) {
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} {
                justify-content: flex-start;
              }
              [mid="${block.id}"] .${styles.overlay}.overlay${block.id} > div {
                margin-top: 67vh;
              }
            }
          `}
        </style>
      )}
      {(block.id === 2420 || block.id === 2450) && (
        <style>
          {`@media only screen and (min-width: 820px) {
            [mid="${block.id}"] .${styles.overlay}.overlay${block.id} > div {
              text-align: center;
              max-width: 30%;
            }
          }`}
        </style>
      )}
      
      <div className={jnstyls([styles.overlay,`overlay${block.id}`, pstyles.overlay, block.id === 2059 ? styles.bttm_cta : ''])}>
        {!!contents && contents.map( (content, contIndex) => {

          content.parent = 'overlay'

          switch (content.type) {
            case 'title':
              return (
                <React.Fragment key={`overlay${index}-${contIndex}`}>
                  {!block.img_title ? (
                    <Title 
                      block={block} 
                      from={'from_ovrly'} 
                      item={content} 
                      index={index} 
                      pstyles={styles}
                    />
                  ) : (
                    <ImgTitle 
                      block={block} 
                      from={'from_ovrly'} 
                      img_title={block.img_title} 
                      desk_height={block.img_title_dheight}
                      mobi_height={block.img_title_mheight}
                      title={alt_title}
                      klass={`overimgtitle${block.id}`}
                    />
                  )}
                </React.Fragment>
              );
            case 'subtitle':
              return (
                <Subtitle 
                  block={block} 
                  from={'from_ovrly'} 
                  key={`overlay${index}-${contIndex}`} 
                  item={content} 
                  index={index} 
                  pstyles={styles} 
                />
              )
            case 'body':
              return (
                <Body 
                  block={block} 
                  from={'from_ovrly'} 
                  key={`overlay${index}-${contIndex}`} 
                  copy={content.copy} 
                  index={index} 
                  pstyles={styles} 
                />
              )
            case 'cta':
              return (
                <Ctas 
                  block={block} 
                  from={'from_ovrly'} 
                  key={`overlay${index}-${contIndex}`} 
                  item={content} 
                  index={index} 
                  pstyles={styles} 
                />
              )
            default:
              return <React.Fragment key={`overlay${index}-${contIndex}`} />
          }
        })}
      </div>
    </>
  )
}


const Captions = ({ block, item, is_text, index, pstyles={} }) => {
  const show_mobile = item.hasOwnProperty('show_mobile') && item.show_mobile === 'false' ? styles.nomob : '' 

  return (
    <div 
      className={jnstyls([is_text ? styles.nd_text : styles.hcaption, pstyles.hcaption, show_mobile])} 
      {...(is_text ? { 'mok-block': index } : {})}
    >
      {item.map( (caption, captIndex) => {
        const capt_class = captIndex === 0 ? styles.capleft : styles.capright
        
        return (
          <div 
            key={`capt${index}-${captIndex}`}  
            className={jnstyls([capt_class, is_text ? styles.text_block : ''])}
          >
            {caption.contents && caption.contents.map( (content, contIndex) => {
              switch (content.type) {
                case 'title':
                  return (
                    <React.Fragment key={`capt${index}-${contIndex}`}>
                      {!caption.img_title ? (
                        <Title 
                          block={block} 
                          from={'from_capts'} 
                          item={content} 
                          index={index} 
                        />
                      ) : (
                        <ImgTitle 
                          block={block} 
                          from={'from_capts'} 
                          img_title={caption.img_title} 
                          desk_height={caption.img_title_dheight}
                          mobi_height={caption.img_title_mheight}
                          title={content}
                          klass={`caption${index}-${captIndex}-${contIndex}`}
                        />
                      )}
                    </React.Fragment>
                  );
                case 'subtitle':
                  return (
                    <Subtitle 
                      key={`capt${index}-${contIndex}`}
                      block={block} 
                      from={'from_capts'} 
                      item={content} 
                      index={index} 
                    />
                  )
                case 'body':
                  return (
                    <Body 
                      key={`capt${index}-${contIndex}`} 
                      block={block} 
                      from={'from_capts'} 
                      copy={content.copy} 
                      index={index} 
                    />
                  )
                case 'cta':
                  return (
                    <Ctas 
                      key={`capt${index}-${contIndex}`} 
                      block={block} 
                      from={'from_capts'} 
                      item={content} 
                      index={index} 
                    />
                  )
                default:
                  return <React.Fragment key={`capt${index}-${contIndex}`} />
              }
            })}
          </div>
        )
      })}
    </div>
  )
}

export { Overlay, Captions }

